import { z } from "zod";
import { constants } from "~/common/constants";
import {
  EMAIL_FIELD_SCHEMA,
  FIRST_NAME_FIELD_SCHEMA,
  LAST_NAME_FIELD_SCHEMA,
} from "~/lib/shared/schemas/fieldSchemas";

export const requestDemoSchema = z.object({
  firstName: FIRST_NAME_FIELD_SCHEMA,
  lastName: LAST_NAME_FIELD_SCHEMA,
  email: EMAIL_FIELD_SCHEMA,
  title: z.string().min(1, { message: "Title is required" }),
  organization: z.string().min(1, { message: "Organization is required" }),
  howCanWeHelp: z.string().max(1000).optional(),
  salesforceCampaignId: z
    .union([z.string(), z.number()])
    .transform((val) => val?.toString()),

  [constants.TURNSTILE_RESULT_PROPERTY]: z.string().nullable().optional(),
});

const baseFormSchema = requestDemoSchema.extend({
  analyticsUserId: z.string().nullable().default(null),
  analyticsAnonymousId: z.string().nullable().default(null),
});

export const createDemoFormSchema = (turnstileRequired: boolean) =>
  baseFormSchema.extend({
    [constants.TURNSTILE_RESULT_PROPERTY]: turnstileRequired
      ? z.string()
      : z.string().nullable().optional(),
  });

/** Schema used by the server */
export type RequestDemoSchema = z.infer<typeof requestDemoSchema>;

/** Schema used by the client */
export type RequestDemoFormSchema = z.infer<
  ReturnType<typeof createDemoFormSchema>
>;
